<script setup>
import { defineProps } from 'vue';
defineProps({
    modalId: { type: String, required: true },
    title: { type: String, default: '' },
    message: { type: String, default: '' },
    buttons: { type: Array, default: () => [] }
});
</script>

<template>
    <div class="modal fade" :id="modalId" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ title }}</h5>
                </div>
                <div class="modal-body text-dark fw-bold">
                    <slot>
                        {{ message }}
                    </slot>
                </div>
                <div class="modal-footer justify-content-center">
                    <button v-for="(btn, idx) in buttons" :key="idx" :class="btn.class" @click="btn.onClick"
                        data-bs-dismiss="modal">
                        {{ btn.label }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.modal-header {
    border-bottom: none;
    /* 下線を除去 */
}

.modal-footer {
    border-top: none;
    /* 上線を除去 */
}
</style>